import { useEffect } from "react";

export default function Ga4Provider() {
  const enabled = (process.env.REACT_APP_GA4_ENABLED || "false") === "true";
  const measurementId = process.env.REACT_APP_GA4_ID;

  useEffect(() => {
    if (!enabled) return;
    if (!measurementId) return;

    // evita duplicar se rerender
    if (document.querySelector(`script[data-ga4="${measurementId}"]`)) return;

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    s1.setAttribute("data-ga4", measurementId);
    document.head.appendChild(s1);

    const s2 = document.createElement("script");
    s2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = window.gtag || gtag;
      gtag('js', new Date());
      gtag('config', '${measurementId}', { send_page_view: false });
    `;
    document.head.appendChild(s2);
  }, [enabled, measurementId]);

  return null;
}